"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.crosshairPlugin = void 0;
var _constants = require("./constants");
var _errors = require("../../../utils/errors");
/** Кастомный плагин chart.js, реализующий отрисовку вертикальной линии на активной точке графика */
const crosshairPlugin = logger => {
  return {
    id: 'crosshairPlugin',
    beforeDraw: chart => {
      try {
        if (chart.tooltip?.getActiveElements().length) {
          const x = chart.tooltip._active[0].element.x;
          const yAxis = chart.scales.y;
          const ctx = chart.ctx;
          ctx.save();
          ctx.beginPath();
          ctx.moveTo(x, yAxis.top);
          ctx.lineTo(x, yAxis.bottom);
          ctx.lineWidth = 1;
          ctx.strokeStyle = _constants.TICKS_COLOR;
          ctx.stroke();
          ctx.restore();
        }
      } catch (e) {
        logger.error(new _errors.ChartInteractionError({
          domain: 'crosshairPlugin.ts',
          message: e.message
        }));
        chart.ctx.restore();
      }
    }
  };
};
exports.crosshairPlugin = crosshairPlugin;